/** Called as a voiceover starts to be spoken again; what it returns runs once its scenes are re-timed. */
export type VoiceoverRespeakWatcher = (sceneGroupId: string) => () => void;

let watcher: VoiceoverRespeakWatcher | null = null;

/**
 * Lets the editor follow a voiceover being spoken again without the transcript operations importing
 * what it does about it: handing graphics to the agent sits far above them in the import graph, and
 * importing it from here closes a cycle through the app barrel.
 */
export function watchVoiceoverRespeak(next: VoiceoverRespeakWatcher): () => void {
    watcher = next;
    return () => {
        if (watcher === next) {
            watcher = null;
        }
    };
}

export function startVoiceoverRespeak(sceneGroupId: string): () => void {
    return watcher?.(sceneGroupId) ?? (() => {});
}
